(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift"] && !Shopify.designMode) return;
  try {
    
  class GiftPage extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._ready) return;
      this._ready = true;
      const q = (s) => this.querySelector(s);

      this.grid = q('[data-gp-grid]');
      this.promo = q('[data-gp-promo]');
      this.sortEl = q('[data-gp-sort]');
      this.countEl = q('[data-gp-count]');
      this.more = q('[data-gp-more]');
      this.empty = q('[data-gp-empty]');
      this.toastEl = q('[data-gp-toast]');
      this.bar = q('[data-gp-bar]');
      this.chipsWrap = q('.gp-chips');
      this.step = +this.dataset.step || 12;
      this.shown = this.step;
      this.promoPos = Math.max(0, +this.dataset.promoPos || 0);
      this.cap = Infinity;

      this.items = [...this.querySelectorAll('[data-gp-item]')];
      this.items.forEach((el, i) => {
        el._i = i;
        el._p = (+el.dataset.price || 0) / 100;
        el._c = +el.dataset.created || 0;
        el._t = (el.dataset.tags || '').split('|');
      });

      this.initBudget();

      // Hide gift categories (tags) that have no products at all
      this.chips = [...this.querySelectorAll('[data-gp-chip]')].filter((chip) => {
        const n = this.items.filter((el) => this.match(el, chip)).length;
        if (n === 0 && chip.dataset.type !== 'all') { chip.hidden = true; return false; }
        return true;
      });
      this.active = this.defaultChip();
      if (this.chipsWrap && this.chips.length < 2) this.chipsWrap.hidden = true;
      if (this.bar && !this.budgetOn && this.chips.length < 2) this.bar.hidden = true;

      this.addEventListener('click', (e) => {
        const t = e.target;
        const chip = t.closest('[data-gp-chip]');
        if (chip) { this.active = chip; this.shown = this.step; return this.render(); }
        if (t.closest('[data-gp-load]')) { this.shown += this.step; return this.render(); }
        if (t.closest('[data-gp-reset]')) { this.active = this.defaultChip(); this.resetBudget(); return this.render(); }
        const sw = t.closest('[data-gp-sw]');
        if (sw) return this.swatch(sw);
        const qa = t.closest('button[data-gp-qa]');
        if (qa) return this.add(qa);
        if (t.closest('[data-gp-gift]')) return this.openGift();
        if (t.closest('[data-gp-close]')) return this.closeGift();
        const idea = t.closest('[data-gp-idea]');
        if (idea) return this.useIdea(idea.dataset.text);
        if (t.closest('[data-gp-clear]')) return this.saveGift(true);
      });
      if (this.sortEl) this.sortEl.addEventListener('change', () => { this.shown = this.step; this.render(); });

      this.initGift();
      this.render();
      this.dataset.ready = '';
    }

    defaultChip() {
      return this.chips.length > 1 ? this.chips[0] : null;
    }

    fmt(n) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: this.dataset.currency || 'USD', maximumFractionDigits: 0,
        }).format(n);
      } catch (_) {
        return '$' + n;
      }
    }

    /* ---------- Budget slider ---------- */
    initBudget() {
      this.budget = this.querySelector('[data-gp-budget]');
      this.range = this.querySelector('[data-gp-range]');
      this.bval = this.querySelector('[data-gp-bval]');
      this.budgetOn = false;
      if (!this.range) return;
      const prices = this.items.map((i) => i._p);
      const lo = prices.length ? Math.min(...prices) : 0;
      const hi = prices.length ? Math.max(...prices) : 0;
      const span = hi - lo;
      const step = span <= 100 ? 5 : span <= 600 ? 10 : 25;
      this.bmin = Math.floor(lo / step) * step;
      this.bmax = Math.ceil(hi / step) * step;
      if (!prices.length || this.bmin === this.bmax) { this.budget.hidden = true; return; }

      this.budgetOn = true;
      Object.assign(this.range, { min: this.bmin, max: this.bmax, step: step, value: this.bmax });
      this.cap = this.bmax;

      const ship = +this.dataset.ship;
      this.mark = this.querySelector('[data-gp-mark]');
      this.shipAt = 0;
      if (this.mark && ship > this.bmin && ship < this.bmax) {
        const m = (ship - this.bmin) / (this.bmax - this.bmin);
        this.shipAt = ship;
        this.mark.style.setProperty('--m', m);
        this.mark.dataset.edge = m < 0.18 ? 'start' : m > 0.82 ? 'end' : 'mid';
        this.mark.querySelector('[data-gp-mlabel]').textContent = (this.dataset.tShip || '').replace('{amount}', this.fmt(ship));
        this.mark.hidden = false;
      }
      this.range.addEventListener('input', () => {
        this.cap = +this.range.value;
        this.shown = this.step;
        this.render();
      });
    }

    resetBudget() {
      if (!this.budgetOn) return;
      this.range.value = this.bmax;
      this.cap = this.bmax;
    }

    syncBudget() {
      if (!this.budgetOn) return;
      const p = (this.cap - this.bmin) / (this.bmax - this.bmin);
      this.range.style.setProperty('--p', p);
      this.bval.textContent = this.cap >= this.bmax
        ? this.dataset.tAny
        : (this.dataset.tUpto || '').replace('{amount}', this.fmt(this.cap));
      if (this.mark && this.shipAt) this.mark.classList.toggle('is-on', this.cap >= this.shipAt);
    }

    /* ---------- Filter / sort / render ---------- */
    match(el, chip) {
      if (!chip) return true;
      const v = (chip.dataset.value || '').trim().toLowerCase();
      switch (chip.dataset.type) {
        case 'price_max': return el._p <= parseFloat(v);
        case 'price_min': return el._p >= parseFloat(v);
        case 'tag': return el._t.includes(v);
        default: return true;
      }
    }

    render() {
      const mode = this.sortEl ? this.sortEl.value : 'featured';
      const sorters = {
        featured: (a, b) => a._i - b._i,
        newest: (a, b) => b._c - a._c,
        'price-asc': (a, b) => a._p - b._p,
        'price-desc': (a, b) => b._p - a._p,
      };
      const list = this.items
        .filter((el) => this.match(el, this.active) && el._p <= this.cap)
        .sort(sorters[mode] || sorters.featured);
      const order = list.slice();
      if (this.promo && mode === 'featured' && list.length) {
        order.splice(Math.min(this.promoPos, order.length), 0, this.promo);
      }

      this.items.forEach((el) => { el.hidden = true; });
      if (this.promo) this.promo.hidden = true;
      let n = 0;
      order.forEach((el) => {
        this.grid.appendChild(el);
        if (el === this.promo) { el.hidden = false; return; }
        el.hidden = n >= this.shown;
        n++;
      });

      const total = list.length;
      const vis = Math.min(total, this.shown);
      this.chips.forEach((c) => {
        c.setAttribute('aria-pressed', c === this.active);
        const k = this.items.filter((el) => this.match(el, c) && el._p <= this.cap).length;
        const badge = c.querySelector('[data-gp-chip-n]');
        if (badge) badge.textContent = k;
        c.classList.toggle('is-empty', k === 0 && c.dataset.type !== 'all');
      });
      this.syncBudget();
      if (this.countEl) this.countEl.textContent = (this.dataset.tCount || '{count}').replace('{count}', total);
      if (this.empty) this.empty.hidden = total > 0;
      if (this.more) {
        this.more.hidden = total <= vis;
        this.more.querySelector('[data-gp-meta]').textContent = (this.dataset.tShowing || '').replace('{shown}', vis).replace('{total}', total);
        this.more.querySelector('[data-gp-bar]').style.width = (total ? (vis / total) * 100 : 0) + '%';
      }
    }

    /* ---------- Card: swatches + quick add ---------- */
    swatch(sw) {
      const card = sw.closest('[data-gp-item]');
      card.querySelectorAll('[data-gp-sw]').forEach((s) => {
        s.classList.toggle('is-active', s === sw);
        s.setAttribute('aria-pressed', s === sw);
      });
      const qa = card.querySelector('button[data-gp-qa]');
      if (qa && sw.dataset.variant) {
        qa.dataset.variant = sw.dataset.variant;
        qa.disabled = sw.dataset.available === 'false';
      }
      card.querySelectorAll('a[data-gp-link]').forEach((a) => {
        a.href = a.dataset.base + '?variant=' + sw.dataset.variant;
      });
      const img = card.querySelector('.gp-card__img--main');
      if (img && sw.dataset.img) {
        img.src = sw.dataset.img;
        if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
        card.classList.remove('has-alt');
      }
    }

    get root() {
      return (this.dataset.root || '/').replace(/\/?$/, '/');
    }

    async post(path, body) {
      const res = await fetch(this.root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Request failed');
      return data;
    }

    async add(btn) {
      if (btn.dataset.state) return;
      btn.dataset.state = 'loading';
      try {
        await this.post('cart/add.js', { items: [{ id: +btn.dataset.variant, quantity: 1 }] });
        btn.dataset.state = 'done';
        const actions = [{ label: this.dataset.tView, href: this.dataset.cartUrl }];
        if (this.dlg && !this.giftSaved) actions.push({ label: 'Add gift message', fn: () => this.openGift() });
        this.toast(this.dataset.tAdded, actions);
        this.syncCart();
      } catch (err) {
        btn.dataset.state = 'error';
        this.toast(err.message || 'Could not add to bag. Please try again.');
      }
      setTimeout(() => { delete btn.dataset.state; }, 1800);
    }

    toast(msg, actions = []) {
      const el = this.toastEl;
      if (!el) return;
      el.textContent = '';
      const span = document.createElement('span');
      span.textContent = msg;
      el.append(span);
      actions.forEach((a) => {
        const node = document.createElement(a.href ? 'a' : 'button');
        if (a.href) node.href = a.href; else node.type = 'button';
        node.textContent = a.label;
        if (a.fn) node.addEventListener('click', a.fn);
        el.append(node);
      });
      el.classList.add('is-on');
      clearTimeout(this._tt);
      this._tt = setTimeout(() => el.classList.remove('is-on'), 4200);
    }

    // Best-effort header cart count refresh; also notify themes that listen for cart events
    async syncCart() {
      ['cart:refresh', 'cart:updated'].forEach((n) => document.dispatchEvent(new CustomEvent(n, { bubbles: true })));
      try {
        const cart = await (await fetch(this.root + 'cart.js')).json();
        document.querySelectorAll('[data-cart-count], .cart-count, #CartCount, .cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
          el.textContent = cart.item_count;
        });
      } catch (_) { /* ignore */ }
    }

    /* ---------- Gift message (stored as cart attributes) ---------- */
    initGift() {
      this.dlg = this.querySelector('[data-gp-dlg]');
      this.giftSaved = false;
      if (!this.dlg) return;
      const f = this.dlg.querySelector('[data-gp-form]');
      this.gf = { to: f.elements.to, from: f.elements.from, msg: f.elements.msg };
      Object.values(this.gf).forEach((input) => input.addEventListener('input', () => this.preview()));
      f.addEventListener('submit', (e) => { e.preventDefault(); this.saveGift(false); });
      this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.closeGift(); });
      this.dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
      this.loadGift();
    }

    preview() {
      const { to, from, msg } = this.gf;
      const set = (sel, v, fallback) => { this.dlg.querySelector(sel).textContent = v.trim() || fallback; };
      set('[data-gp-pv-to]', to.value, '…');
      set('[data-gp-pv-from]', from.value, '…');
      const pv = this.dlg.querySelector('[data-gp-pv-msg]');
      pv.textContent = msg.value.trim() || 'Your message will appear here.';
      pv.classList.toggle('is-empty', !msg.value.trim());
      this.dlg.querySelector('[data-gp-counter]').textContent = msg.value.length + ' / 180';
    }

    setGiftState(on) {
      this.giftSaved = on;
      this.querySelectorAll('button[data-gp-gift].gp-giftbtn').forEach((b) => {
        b.classList.toggle('is-on', on);
        b.querySelector('[data-gp-gift-label]').textContent = on ? 'Edit gift message' : 'Add a gift message';
      });
      this.dlg.querySelector('[data-gp-clear]').hidden = !on;
    }

    async loadGift() {
      try {
        const cart = await (await fetch(this.root + 'cart.js')).json();
        const a = cart.attributes || {};
        this.gf.to.value = a['Gift to'] || '';
        this.gf.from.value = a['Gift from'] || '';
        this.gf.msg.value = a['Gift message'] || '';
        this.preview();
        this.setGiftState(!!a['Gift message']);
      } catch (_) { /* ignore */ }
    }

    openGift() {
      if (!this.dlg || typeof this.dlg.showModal !== 'function') return;
      this.toastEl.classList.remove('is-on');
      document.documentElement.style.overflow = 'hidden';
      this.dlg.showModal();
      this.gf.msg.focus();
    }

    closeGift() {
      if (this.dlg && this.dlg.open) this.dlg.close();
    }

    useIdea(text) {
      this.gf.msg.value = text.slice(0, 180);
      this.preview();
      this.gf.msg.focus();
    }

    async saveGift(clear) {
      const msg = this.gf.msg.value.trim();
      if (!clear && !msg) { this.gf.msg.focus(); return; }
      const saveBtn = this.dlg.querySelector('[data-gp-save]');
      saveBtn.disabled = true;
      try {
        await this.post('cart/update.js', {
          attributes: {
            'Gift to': clear ? '' : this.gf.to.value.trim(),
            'Gift from': clear ? '' : this.gf.from.value.trim(),
            'Gift message': clear ? '' : msg,
          },
        });
        if (clear) {
          Object.values(this.gf).forEach((input) => { input.value = ''; });
          this.preview();
        }
        this.setGiftState(!clear);
        this.closeGift();
        this.toast(clear ? 'Gift message removed' : 'Gift message saved', clear ? [] : [{ label: this.dataset.tView, href: this.dataset.cartUrl }]);
      } catch (err) {
        this.toast(err.message || 'Could not save the message. Please try again.');
      }
      saveBtn.disabled = false;
    }
  }
  if (!customElements.get('gift-page')) customElements.define('gift-page', GiftPage);

  } catch(e) { console.error(e); }
})();
})();
